import { BACKEND_SERVICE_UPDATE_CURRENT_MEMBER } from './actions';

export const initialState = {
  currentMember: null,
};

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [BACKEND_SERVICE_UPDATE_CURRENT_MEMBER]: (state, action) => ({
    ...state,
    ...action.payload,
  }),
};

// ------------------------------------
// Reducer
// ------------------------------------
// oxlint-disable-next-line default-param-last
export const reducer = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
};
